import { ProductBundle, ProductType } from '@typesApp/Product'

type ProductTypeKey = keyof typeof ProductType

const LENS_PRODUCT_TYPES: ProductTypeKey[] = [
  'BIFOCAL_LENS',
  'LENS_PACKAGE',
  'NO_PRESCRIPTION_LENS',
  'PLANO_LENS',
  'PRESCRIPTION_LENS',
  'PROGRESSIVE_LENS',
  'READER_LENS',
  'SINGLE_VISION_LENS',
  'ZERO_PRICE_BASE_LENS',
]

const FRAME_PRODUCT_TYPES: ProductTypeKey[] = [
  'FRAME',
  'FRAME_ONLY',
  'RIMLESS_FRAME',
  'GLASSES',
  'SUNGLASSES',
  'PRESCRIPTION_SUNGLASSES',
]

const CONTACTS_PRODUCT_TYPES: ProductTypeKey[] = [
  'COLORED_PLANO_CONTACT_LENS',
  'PRESCRIPTION_CONTACT_LENS',
  'MEDICAL_CONDITION_CONTACT_LENS',
]

export const isLensProductType = (productType: ProductType | undefined): boolean =>
  !!productType && LENS_PRODUCT_TYPES.includes(productType)

export const isFrameProductType = (productType: ProductType | undefined): boolean =>
  !!productType && FRAME_PRODUCT_TYPES.includes(productType)

export const isContactLensProductType = (productType: ProductType | undefined): boolean =>
  !!productType && CONTACTS_PRODUCT_TYPES.includes(productType)

export const isContactLensBundle = (product: ProductBundle): boolean => {
  const isContactLens = product?.cartProducts?.find(
    p =>
      p.claimProductTypes?.includes(ProductType.PRESCRIPTION_CONTACT_LENS) ||
      p.claimProductTypes?.includes(ProductType.COLORED_PLANO_CONTACT_LENS) ||
      p.claimProductTypes?.includes(ProductType.MEDICAL_CONDITION_CONTACT_LENS)
  )
  return Boolean(isContactLens)
}
